<template>
  <transition name="modal">
    <div class="modal-mask" v-show="!!sub" ref="modal" tabindex="0">
      <div class="modal-wrapper modal-sub-process">
        <div class="modal-container">

<!--    <div class="modal" tabindex="-1" role="dialog"  v-show="!!sub">-->
<!--      <div class="modal-dialog modal-sub-info" role="document">-->
<!--        <div class="modal-content">-->

          <div class="modal-header">
            <slot name="header">
              <div class="modal-title">Подписка</div>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="doClose">
                <!--<span class="icon" aria-hidden="true">&times;</span>-->
              </button>
            </slot>
          </div>

          <div class="modal-body">
            <slot name="body">
              <div class="loader" v-if="loading">
                <!--<div class="animation"></div>-->
                <div class="text">Загрузка</div>
              </div>
              <div class="form" :class="{'has-error': !!errorMessage}" v-if="!loading && !subscribeComplete">
                <div class="phone-number-label" v-if="!!msisdn">
                     <span class="msisdn">{{msisdn}}</span>
                </div>
                <label class="phone-number-input" v-if="!msisdn">
                  <span>Номер телефона</span>
                  <input name="msisdn" v-model="inputMsisdn" placeholder="992 ХХХ ХХХ ХХХ" type="tel" maxlength="20" ref="inputMsisdn" @keydown.enter="doNext">
                </label>
                <label class="sms-code-input" v-if="!!msisdn">
                  <span>Код из СМС</span>
                  <input name="code" v-model="inputCode" autocomplete="off" type="text" pattern="\d*" maxlength="4" ref="inputCode" @keydown.enter="doNext">
                </label>
                <div class="error" v-if="!!errorMessage">
                  <!--Введите код из СМС-->
                  {{errorMessage}}
                </div>
              </div>
              <div class="result" v-if="subscribeComplete">
                Подписка <span class="label">{{attr(f.TITLE)}}</span> подключена на номере
                <!--<span class="msisdn">+7 (999) 999 99 99</span>-->
                <span class="msisdn">{{msisdn}}</span>
              </div>
            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              <mf-button @click.stop="doNext" :text="`${$t('message.subscribe')}`" :style="`solid-button`" v-if="!subscribeComplete"></mf-button>
              <mf-button @click.stop="doClose" :text="`OK`" :style="`solid-button`" v-if="subscribeComplete"></mf-button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script lang="ts">
import {defineComponent} from 'vue'
import {useDataService} from "../store/DataService";
import {useSubscriptionService} from '../store/SubsctiptionService';
import {Language} from "../entity/Core";
import {ResponseCode, SubFact, SubItem} from "../entity/SubData";
import MfButton from "./mf-button.vue";
import {AxiosError} from "axios/index.d.ts";
export default defineComponent({
  name: 'SubscriptionProcess',
  props: {
    'sub': Object, // SubItem,
  },
  components: {
    MfButton
  },
  data() {
    return {
      subscriptionService: null,
      loading: true,
      msisdn: null,
      errorMessage: false,
      inputMsisdn: "",
      inputCode: "",
      subscribeComplete: false,
      f: SubFact
    }
  },
  methods: {
    subId(): string {
      return !this.sub ? null : this.sub.id;
    },
    attr(fact: SubFact): string {
      const si: SubItem = this.sub;
      const lang = Language[this.$i18n.locale.toUpperCase()];
      // return !si ? null : si.facts[fact][Language.RU];
      return si?.facts?.[fact]?.[lang];
    },
    doSendCode(emmitError: boolean = true) {
      if (!!this.inputMsisdn && this.inputMsisdn.length >= 1 ) {
        console.info(this.inputMsisdn);
        console.info(this.subId());
        this.dataService.sendCode(this.inputMsisdn, this.subId())
            .then(response => {
              const result: ResponseCode = response;

              console.info("result doSendCode");
              console.info(result);

              // todo process
              switch (result) {
                case ResponseCode.SUCCESS_SEND:
                  this.msisdn = this.inputMsisdn;
                  break;
                case ResponseCode.SUCCESS_SUB:
                  this.subscribeComplete = true;
                  break;
                case ResponseCode.UNSUCCESS_SUB:
                  this.errorMessage = "Ошибка при подписке";
                  break;
                case ResponseCode.NO_MONEY:
                  this.errorMessage = "Недостаточно средств";
                  break;
                case ResponseCode.BAD_CODE:
                  this.errorMessage = "Некорректный код";
                  break;
                case ResponseCode.ALREADY_SENT:
                  this.errorMessage = "Код уже отправлен";
                  break;
                case ResponseCode.RETRY_SEND:
                  this.msisdn = this.inputMsisdn;
                  break;
                case ResponseCode.ERROR:
                  this.errorMessage = "Ошибка";
                  break;
                case ResponseCode.ATTEMPT_LIMIT:
                  this.errorMessage = "Количество попыток исчерпано";
                  break;
                default:
                  this.errorMessage = "Неизвестный ответ";
              }
            })
            .catch(error => {
              console.log(error);
              const err: AxiosError = error as AxiosError;
              const details = !!err.message ? ` ( ${err.message})` : '';
              this.errorMessage = "Ошибка при запросе на проверку кода" + details;
            })
            .finally(() => {
              this.loading = false;
              if (!this.subscribeComplete) {
                setTimeout(() => {
                  this.$refs.inputCode.focus();
                }, 15)
              }
            });
      } else {
        if (emmitError) {
          this.errorMessage = "Введите номер телефона";
        }
      }
    },
    doVerifyCode(emmitError: boolean = true) {
      if (!!this.inputCode && this.inputCode.length >= 1 ) {
        console.info(this.inputMsisdn);
        console.info(this.subId());
        console.info(this.inputCode);
        this.dataService.verifyCode(this.inputMsisdn, this.subId(), this.inputCode)
            .then(response => {
              const result: ResponseCode = response;

              console.info("result doVerifyCode");
              console.info(result);
              // todo process

              switch (result) {
                case ResponseCode.SUCCESS_SEND:
                  this.errorMessage = "Код отправлен";
                  break;
                case ResponseCode.SUCCESS_SUB:
                  this.subscribeComplete = true;
                  break;
                case ResponseCode.UNSUCCESS_SUB:
                  this.errorMessage = "Ошибка при подписке";
                  break;
                case ResponseCode.NO_MONEY:
                  this.errorMessage = "Недостаточно средств";
                  break;
                case ResponseCode.BAD_CODE:
                  this.errorMessage = "Некорректный код";
                  break;
                case ResponseCode.ALREADY_SENT:
                  this.errorMessage = "Код уже отправлен";
                  break;
                case ResponseCode.RETRY_SEND:
                  this.errorMessage = "Код отправлен";
                  break;
                case ResponseCode.ERROR:
                  this.errorMessage = "Ошибка";
                  break;
                case ResponseCode.ATTEMPT_LIMIT:
                  this.errorMessage = "Количество попыток исчерпано";
                  break;
                default:
                  this.errorMessage = "Неизвестный ответ";
              }
            })
            .catch(error => {
              console.log(error);
              const err: AxiosError = error as AxiosError;
              const details = !!err.message ? ` ( ${err.message})` : '';
              this.errorMessage = "Ошибка при запросе на проверку кода" + details;
            })
            .finally(() => {
              this.loading = false;
              if (!this.subscribeComplete) {
                setTimeout(() => {
                  this.$refs.inputCode.focus();
                }, 15)
              }
            });
      } else {
        if (emmitError) {
          this.errorMessage = "Введите код из СМС";
        }
      }
    },
    doNext(emmitError: boolean = true) {
      // reset error
      this.errorMessage = null;
      if (!this.msisdn) {
        // no MSISDN - try to obtain
        this.doSendCode(emmitError);
      } else {
        // obtain SMS code
        this.doVerifyCode(emmitError);
      }
    },
    doClose() {
      this.onMsisdn(null);
      this.subscribeComplete = false;
      this.errorMessage = null;
      this.$emit('close');
    },
    onMsisdn(msisdn: string | null | undefined, ifExist: (string) => {} | null | undefined = null) {
      if (!!msisdn && msisdn.length > 0) {
        this.msisdn = msisdn;
        this.inputMsisdn = msisdn;
        if (!!ifExist) {
          ifExist(msisdn)
        }
        setTimeout(() => {
          this.$refs.inputCode.focus();
        }, 5)
      } else {
        this.msisdn = null;
        this.inputMsisdn = null;
        setTimeout(() => {
          this.$refs.inputMsisdn.focus();
        }, 5);
      }
    },
    subscribe() {
      this.subscriptionService.doSubscribe(this.sub.id);
    },
    requestAssistance() {
      this.subscriptionService.doRequestAssistance(this.sub);
    },
    requestRegulations() {
      this.subscriptionService.doRequestRegulations(this.sub);
    },
  },
  mounted() {
    this.subscriptionService = useSubscriptionService();
    this.dataService = useDataService();
    this.loading = false;
  },
  watch: {
    sub: function(newVal, oldVal) {
      if (!!newVal) {
        this.onMsisdn(this?.$root.msisdn, (msisdn) => this.doSendCode(false));
      }
    }
  }
})
</script>
<style lang="scss" scoped>
@import "../../scss/variables";
@import "../../scss/mixins";
.modal-sub-process {
  .solid-button {
    @include button($green, $white, 50px);
  }
}
</style>
